export default {
  default: () => import("/opt/build/repo/layouts/default.vue"),
  empty: () => import("/opt/build/repo/layouts/empty.vue"),
  login: () => import("/opt/build/repo/layouts/login.vue"),
  "no-navbar": () => import("/opt/build/repo/layouts/no-navbar.vue")
}